import { hashNameAndSize } from './util/FileUtils';

export class GlobalVariables {
    private static files: Map<string, File> = new Map<string, File>();

    static addFile(file: File): string {
        const hash = hashNameAndSize(file);
        this.files.set(hash, file);

        return hash;
    }

    static getFileById(id: string): File | null {
        return this.files.get(id) ?? null;
    }

    static getAllFiles(): File[] {
        return Array.from(this.files.values());
    }

    static removeFileById(id?: string): void {
        if (!id) {
            return;
        }
        this.files.delete(id);
    }

    static resetFiles(): void {
        this.files.clear();
    }
}
